import { fetchPgoReviews } from "../services/pgoApi";
import { renderCategoryScores } from "../utils/pgoStarsUtils";

export const starReviewRenderer = (pgoId) => ({
    data: {},
    scores: null,
    pgoId: pgoId,
    loading: false,
    error: false,

    init() {
        this.loading = true;
        this.render();
    },
    
    async render() {
        try {
            const review = await fetchPgoReviews(this.pgoId);
    
            if (!review || !review.categoryScores) {
                console.warn("Review data or categoryScores missing:", review);
                return;
            }
    
            this.data = review;
            this.loading = false;
            this.error = false;
            
        } catch (error) {
            this.error = true;
            console.error("Error rendering stars:", error);
        }
    },

    getStarReviews() {
        if (!this.data?.categoryScores?.length) {
            this.error = true;
            return document.createTextNode("Geen reviews beschikbaar");
        }
    
        return renderCategoryScores(this.data.categoryScores);
    }
    
});
